import styled from "styled-components";
import * as Dialog from "@radix-ui/react-dialog";

export const Overlay = styled(Dialog.Overlay)`
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.75);
    z-index: 80;
`;

export const ContentShell = styled(Dialog.Content)`
    position: fixed;
    inset: 0;
    display: flex;
    justify-content: flex-end;
    align-items: stretch;
    z-index: 90;
    outline: none;
`;

export const DialogPanel = styled.section`
    width: 480px;
    max-width: 100%;
    height: 100%;
    background: #020617;
    border-left: 1px solid rgba(148, 163, 184, 0.2);
    padding: 32px 32px 40px;
    box-sizing: border-box;
    overflow-y: auto;
    box-shadow: -24px 0 80px rgba(15, 23, 42, 0.9);

    @media (max-width: 640px) {
        width: 100%;
        padding: 24px 20px 32px;
    }
`;

type PlanCardProps = {
    $active?: boolean;
};

export const PlanCard = styled.button<PlanCardProps>`
    width: 100%;
    border-radius: 16px;
    padding: 16px 18px;
    border: 1px solid ${(
        { $active },
    ) => ($active ? "#5E84ED" : "rgba(148, 163, 184, 0.35)")};
    background: ${({ $active }) =>
        $active
            ? "radial-gradient(circle at top left, rgba(94, 132, 237, 0.18), rgba(15, 23, 42, 1))"
            : "rgba(15, 23, 42, 0.7)"};
    cursor: pointer;
    text-align: left;
    transition:
        border-color 0.16s ease-out,
        background-color 0.16s ease-out,
        box-shadow 0.16s ease-out,
        transform 0.12s ease-out;
    display: flex;
    flex-direction: column;

    &:hover {
        border-color: #5e84ed;
        box-shadow: 0 0 0 1px rgba(94, 132, 237, 0.4);
        transform: translateY(-1px);
    }

    &:focus-visible {
        outline: 2px solid #5e84ed;
        outline-offset: 2px;
    }
`;

export const PlanHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
`;

export const Badge = styled.div`
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
`;

export const FeatureListWrap = styled.div`
    margin-top: 12px;
`;
